// extracted by mini-css-extract-plugin
module.exports = {"storeButton":"StoreLink_storeButton__E_qxu","dark":"StoreLink_dark__zWSbW","light":"StoreLink_light__CeYEk","sizeS":"StoreLink_sizeS__PoZ79","sizeM":"StoreLink_sizeM__SN2Hj"};